export default __webpack_public_path__ + "static/media/4.26622a57.jpg";